import { useState } from 'react'

export const useToggleMenu = (): [boolean, () => void, boolean, () => void] => {
  const [isMenuOpen, setMenuOpen] = useState(false)
  const [isLangOpen, setLangOpen] = useState(false)

  const toggleMenu = () => setMenuOpen((prev) => !prev)
  const toggleLang = () => setLangOpen((prev) => !prev)

  return [isMenuOpen, toggleMenu, isLangOpen, toggleLang]
}
